import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { defaultSettings } from '@hooks/useSettings';
import { request } from '@utils';

interface HookProps {
  transitId: string;
  messageType: string;
}

export const useTriggerTransitNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, messageType }: HookProps) => {
      return request(
        {
          path: `admin/trigger-transit-notification`,
          method: 'POST',
          authenticate: true,
          dataObject: { transitId, messageType },
          baseUrl: `${defaultSettings.apiUrl?.replace('/api/v1', '')}/customs-simulator`,
        },
        true,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success('Simulator notification triggered!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error triggering simulator notification!');
    },
  });
};
